import { gql } from '@apollo/client';
const ADD_PRODUCT_CERTIFICATE = gql `
  mutation AddProductCertificate($name: String!, $description: String, $thumbnail: String) {
    addProductCertificate(name: $name, description: $description, thumbnail: $thumbnail) {
      productCertificate {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_CERTIFICATE;
